// @flow
import Tooltip from 'app/common/ui-next/plain-tooltip';

export default Tooltip;
